/* Cards that are REAL links.
 *
 * A card rendered as <button onClick={navigate(...)}> looks and behaves like a link until
 * someone right-clicks it — then Chrome offers "Look Up", "Copy", "Search Google", and no
 * "Open in New Tab", because as far as the browser is concerned there is nothing to open.
 * Cmd-click, middle-click, "Copy Link Address" and hover-to-see-the-URL are all missing for
 * the same reason.
 *
 * Giving the element a genuine href restores every one of those from the browser, for free.
 * The onClick still runs the SPA navigation on a plain left-click, so nothing gets slower:
 * the href exists for the browser's benefit, not ours.
 *
 *   <a {...cardLinkProps(`/video/${id}`, () => openViewer(id))} className="...">
 *
 * The modifier check is the whole trick. Without it, e.preventDefault() would swallow
 * Cmd-click too and the card would still refuse to open in a new tab — which is the bug
 * this exists to fix.
 */

/** True when the browser should handle the click itself (new tab, new window, download). */
export const isModifiedClick = (e) =>
  e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button !== undefined && e.button !== 0);

/**
 * Props that turn any element into a card-sized link.
 * @param {string} href        real, navigable URL — must resolve on a hard load, not just in-app
 * @param {function} onActivate what a plain left-click should do (usually SPA navigation)
 */
export function cardLinkProps(href, onActivate) {
  return {
    href,
    onClick: (e) => {
      // Let the browser own modified clicks. Returning here (rather than preventing) is what
      // makes Cmd-click and middle-click open a new tab.
      if (isModifiedClick(e)) return;
      e.preventDefault();
      onActivate?.(e);
    },
  };
}
